// MDSwitch.js
import React from 'react';
import Switch from '@mui/material/Switch';
import { styled } from '@mui/material/styles';

const StyledSwitch = styled(Switch)(({ theme }) => ({
    marginTop: -7,  // Réduit l'espace au-dessus
    marginBottom: -7,  // Réduit l'espace en-dessous
    '& .MuiSwitch-track': {
        backgroundColor: '#e9e9ea', // inactive
        border: '0px',
        borderRadius: '50px',
        transition: theme.transitions.create(['background-color', 'border'], {
            duration: 200,
        }),
    },
    '& .MuiSwitch-switchBase.Mui-checked': {
        color: '#239be6',
        // Target the track when the switch is active
        '& + .MuiSwitch-track': {
            backgroundColor: '#239be6 !important',
            borderColor: '#239be6',
            opacity: 1,
        },
        // Add a shadow for the active state
        '& .MuiSwitch-thumb': {
            boxShadow: '4px 4px 6px rgba(35, 155, 230, 0.4)', // Active state shadow
        },
    },
    // Modify the border and add shadow to the thumb
    '& .MuiSwitch-thumb': {
        borderRadius: '50%', // Ensure the round part stays circular
        backgroundColor: '#fff', // White color inside the thumb
        border: '0px', // Default grey when inactive
        transition: theme.transitions.create(['border', 'box-shadow'], {
            duration: 200,
        }),
        // Add shadow around the thumb
        boxShadow: '-2px 4px 6px rgba(0, 0, 0, 0.2)', // Shadow effect
    },
}));

const MDSwitch = (props) => {
    return <StyledSwitch {...props} />;
};

export default MDSwitch;
